import { formatDollarAmount } from 'apps/wrapper/src/components/layout/slideout/patient-profile-widget/utils/format-dollar-amount';
import { CareCreditPatientPrescreenInfo } from 'apps/wrapper/src/types/payment/care-credit';
import { useState } from 'react';
import CareCreditIcon from '../../../../../../../../assets/carecredit_logo.svg';
import { InfoTitle } from '../../overview.styles';
import { CareCreditPreApprovalModal } from './pre-approval-modal';
import { LinkButton } from './carecredit.styles';

export const Credit = ({ careCreditInfo }: { careCreditInfo: CareCreditPatientPrescreenInfo }) => {
  const [showCCPreapproval, setShowCCPreapproval] = useState<boolean>(false);
  const [, setShowCardholderModal] = useState<boolean>(false);

  const onCareCreditClick = () => {
    if (careCreditInfo.preStatus === 'Preapproved') setShowCCPreapproval(!showCCPreapproval);
    else if (careCreditInfo.preStatus === 'Cardholder') setShowCardholderModal(true);
  };

  return (
    careCreditInfo &&
    careCreditInfo.preStatus &&
    careCreditInfo.preApprovedAmount && (
      <>
        <InfoTitle>
          {careCreditInfo.preStatus === 'Preapproved' && 'CareCredit Pre-Approved'}
          {careCreditInfo.preStatus === 'Cardholder' && 'CareCredit Current Cardholder'}
        </InfoTitle>
        <LinkButton sx={{ margin: 0, padding: 0, color: '#000', textDecoration: 'none' }} onClick={onCareCreditClick}>
          {careCreditInfo.preStatus === 'Preapproved' ? formatDollarAmount(careCreditInfo.preApprovedAmount) : '-'}
          <img src={CareCreditIcon} alt="" style={{ width: '18px', marginLeft: '6px' }} />
        </LinkButton>
        <CareCreditPreApprovalModal
          isOpen={showCCPreapproval}
          careCreditInfo={careCreditInfo}
          onClose={onCareCreditClick}
        />
      </>
    )
  );
}

